import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICountriesArray,
  IProgramsArray,
  IStepTwo,
  TError,
} from "./types/StepTwo-inerface";
import {
  fetchCalculation,
  fetchCountries,
  fetchPolicyTemplate,
} from "./action/fetch-step-two";

const initialState: IStepTwo = {
  Insurer: {
    LastName: "",
    FirstName: "",
    MiddleName: "",
    BirthDate: "",
    Gender: "",
    Address: "",
    CountryID: "",
    Phone: "",
    Email: "",
    DocumentDate: "",
    DocumentDepartment: "",
    DepartmentCode: "",
    DocumentNumber: "",
    DocumentSeries: "",
  },
  Insureds: [
    {
      LastName: "",
      FirstName: "",
      MiddleName: "",
      BirthDate: "",
      Gender: "",
      Address: "",
      CountryID: "",
      Phone: "",
      Email: "",
      DocumentDate: "",
      DocumentDepartment: "",
      DepartmentCode: "",
      DocumentNumber: "",
      DocumentSeries: "",
    },
  ],
  RegionID: "",
  CalculationRequestID: "",
  Programs: [],
  BeginDate: "",
  EndDate: "",
  PolicyholderIsSame: true,
  Countries: {
    isLoadingCountries: false,
    errorCountries: [],
    Countries: [],
  },
  KidAgree: false,
  PolicyAgree: false,
  InsuranceRulesAgree: false,
  AcceptanceAgree: false,
  PolicyTemplate: {
    isLoadingPolicyTemplate: false,
    PolicyTemplateDataBase64: "",
    errorsPolicyTemplate: [],
  },
  ProgramsRequest: {
    isLoadingPrograms: false,
    errorPrograms: [],
    ProgramsArray: [],
    RequestID: "",
  },
  FinalPremium: 0
};

export const StepTwoSlice = createSlice({
  name: "StepTwoSlice",
  initialState,
  reducers: {
    updateField: (
      state,
      action: PayloadAction<{
        field: keyof IStepTwo;
        value: IStepTwo[keyof IStepTwo];
      }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value as never;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.Countries.isLoadingCountries = true;
      })
      .addCase(
        fetchCountries.fulfilled,
        (state, action: PayloadAction<{ Countries: ICountriesArray[] }>) => {
          state.Countries.Countries = action.payload.Countries;
          state.Countries.isLoadingCountries = false;
          state.Countries.errorCountries = [];
        }
      )
      .addCase(fetchCountries.rejected, (state, action) => {
        state.Countries.Countries = initialState.Countries.Countries;
        state.Countries.isLoadingCountries = false;
        state.Countries.errorCountries = action.payload as TError;
      })
      .addCase(fetchPolicyTemplate.pending, (state) => {
        state.PolicyTemplate.isLoadingPolicyTemplate = true;
      })
      .addCase(
        fetchPolicyTemplate.fulfilled,
        (
          state,
          action: PayloadAction<{ PolicyTemplateDataBase64: string }>
        ) => {
          state.PolicyTemplate.PolicyTemplateDataBase64 =
            action.payload.PolicyTemplateDataBase64;
          state.PolicyTemplate.isLoadingPolicyTemplate = false;
          state.PolicyTemplate.errorsPolicyTemplate = [];
        }
      )
      .addCase(fetchPolicyTemplate.rejected, (state, action) => {
        state.PolicyTemplate.PolicyTemplateDataBase64 =
          initialState.PolicyTemplate.PolicyTemplateDataBase64;
        state.PolicyTemplate.isLoadingPolicyTemplate = false;
        state.PolicyTemplate.errorsPolicyTemplate = action.payload as TError;
      })
      .addCase(
        fetchCalculation.fulfilled,
        (
          state,
          action: PayloadAction<{
            Programs: IProgramsArray[];
            RequestID: string;
          }>
        ) => {
          state.ProgramsRequest.ProgramsArray = action.payload.Programs;
          state.ProgramsRequest.RequestID = action.payload.RequestID;
          state.ProgramsRequest.isLoadingPrograms = false;
          state.ProgramsRequest.errorPrograms = [];
        }
      )
      .addCase(fetchCalculation.rejected, (state, action) => {
        state.ProgramsRequest.ProgramsArray =
          initialState.ProgramsRequest.ProgramsArray;
        state.ProgramsRequest.RequestID =
          initialState.ProgramsRequest.RequestID;
        state.ProgramsRequest.isLoadingPrograms = false;
        state.ProgramsRequest.errorPrograms = action.payload as TError;
      });
  },
});

export const { updateField } = StepTwoSlice.actions;
export default StepTwoSlice.reducer;
